import { ThemeProvider } from '@mui/material/styles';
import '@tis/shared-tis-ui/style.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { DialogProvider } from './components/Dialog/Dialog';
import LocationTracker from './components/LocationTracker/LocationTracker';
import theme from './components/Theme/Theme';
import './index.scss';
import { persistor, store } from './store/store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const isLocal = import.meta.env.VITE_ENV === 'local';
const RootWrapper = isLocal ? React.StrictMode : React.Fragment;
root.render(
  <RootWrapper>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <LocationTracker />
            <DialogProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </DialogProvider>
          </Router>
        </PersistGate>
      </ThemeProvider>
    </Provider>
  </RootWrapper>
);
